import axios from 'axios';
import schemas from './offline-schemas';

const documentLoader = async (iri: string): Promise<any> => {
    let doc: any;
    let url = iri.split('#')[0];

    if (url.startsWith('did:')) {
        url = `${process.env.REACT_APP_DID_RESOLVER_URL}/did/${url.split(':')[1]}/${url}`;
        console.log("url", url);

        doc = await fetchDoc(url);
        doc = doc?.didDocument;
        console.log("doc", doc);
    } else {
        doc = await fetchDoc(url);
    }

    if (doc) {
        return { document: doc, documentUrl: url };
    }

    throw new Error(`iri ${iri} not supported`);
};

const fetchDoc = (url: string) => {
    return new Promise(async (resolve) => {
        var result: any;

        try {
            result = await axios.get(url);
            console.log("result ==>> ",url, result);
        } catch (error) {
            console.log(error);
        }

        if (!result?.data && url in schemas) {
            console.log("from =====> LOCAL SCHEMA COLLECTION");
            return resolve(schemas[url]);
        }

        if (result?.status !== 200) 
            return resolve(null);
        
        return resolve(result?.data);
    });
};

export default documentLoader;
